import { render } from "./supply_history.vue?vue&type=template&id=6e097ebd&scoped=true"
import script from "./supply_history.vue?vue&type=script&lang=js"
export * from "./supply_history.vue?vue&type=script&lang=js"

import "./supply_history.vue?vue&type=style&index=0&id=6e097ebd&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e097ebd"]])

export default __exports__